export { default } from "./ThemeProvider.js";